/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'feedback-collector.anonymous': 'Ce commentaire est soumis de manière anonyme. Atlassian ne pourra pas vous contacter directement concernant ce commentaire.',
  'feedback-collector.anonymous.title': 'Commentaire anonyme',
  'feedback-collector.can-be-contacted.label': "Oui, les équipes Atlassian peuvent me contacter pour en savoir plus sur mon expérience afin d'améliorer les produits et services Atlassian. J'accepte la <a>Politique de confidentialité Atlassian</a>.",
  'feedback-collector.cancel-button.label': 'Annuler',
  'feedback-collector.default.custom.textarea.label': 'À quoi pensez-vous ?',
  'feedback-collector.enrol-in-research.label': "J'aimerais participer à la recherche produit",
  'feedback-collector.feedback-title': 'Donner votre avis',
  'feedback-collector.form.bug.label': 'Décrivez le bug ou le problème',
  'feedback-collector.form.comment.label': 'Dites-nous tout',
  'feedback-collector.form.empty.label': 'Sélectionnez une option',
  'feedback-collector.form.question.label': 'Que souhaitez-vous savoir ?',
  'feedback-collector.form.suggestion.label': 'Dites-nous ce que vous aimeriez améliorer',
  'feedback-collector.option.bug.label': 'Signaler un bug',
  'feedback-collector.option.comment.label': 'Laisser un commentaire',
  'feedback-collector.option.default.label': 'Sélectionner le sujet de votre feedback',
  'feedback-collector.option.default.placeholder': 'Choisissez un élément',
  'feedback-collector.option.question.label': 'Poser une question',
  'feedback-collector.option.suggestion.label': 'Suggérer une amélioration',
  'feedback-collector.required.fields.summary': "Les champs obligatoires sont marqués d'un astérisque",
  'feedback-collector.submit-button.label': 'Envoyer des commentaires',
  'feedback-collector.success-flag.description': "Vos commentaires nous sont précieux et contribuent à l'amélioration continue de nos produits.",
  'feedback-collector.success-flag.title': 'Merci !',
  'feedback-collector.summary-placeholder': 'Dites-nous tout',
  'proforma-form-builder.feedback-icon-label': 'Commentaire',
  'proforma-form-builder.give-feedback': 'Envoyer un commentaire'
};